import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useT } from '@transifex/react'
import { ApiTaxRate } from '@vend/types'
import { selectLineItems } from '../../state/slices/currentSale/currentSaleSlice'
import { useFormatPercentage } from './formatNumberHooks'

const NO_TAX = 'No Tax'

export const useCalculateFinalTaxName = () => {
  const t = useT()
  const formatPercentage = useFormatPercentage()
  const lineItems = useSelector(selectLineItems)

  const uniqueTaxes = useMemo(() => {
    const uniqueTaxes = new Map<string, ApiTaxRate>()

    lineItems.forEach(lineItem => {
      if (!lineItem.taxInfo) {
        return
      }

      lineItem.taxInfo.rates.forEach(rate => {
        uniqueTaxes.set(rate.id, rate)
      })
    })
    return uniqueTaxes
  }, [lineItems])

  const calculateFinalTaxName = useCallback(() => {
    const numTaxes = uniqueTaxes.size

    if (numTaxes === 0) {
      return ''
    }

    if (numTaxes === 1) {
      const tax = uniqueTaxes.values().next().value
      if (!tax) {
        return ''
      }
      return tax.name === NO_TAX
        ? t(NO_TAX)
        : t('{name} {rate}', {
            name: tax.name,
            rate: formatPercentage(tax.rate),
            _context: 'Tax name with rate, e.g. GST 10%',
          })
    }

    return t('{numTaxes} Taxes', { numTaxes })
  }, [formatPercentage, t, uniqueTaxes])

  return calculateFinalTaxName
}
